export default {
  data() {
    return {
      zc_api_url: process.env.VUE_APP_ZCARD_API + "/payments/reserve_ec",
      zc_merchant_id: "82771477",
      zc_api_key: "WARR1234567890123456789012345678",
      zc_top_vender_id: "60289456",
      installment_fee: {
        3: 0.026,
        6: 0.035,
        9: 0.045,
        12: 0.055,
        18: 0.08,
        24: 0.1,
      },
    };
  },
  methods: {
    CreateZeroCardOrder(order_data) {
      let vm = this;
      return new Promise((resolve) => {
        let url = vm.zc_api_url;
        let order_no =
          "BKEX_" +
          Date.now() +
          "00" +
          Math.floor(Math.random() * Math.floor(8999)) +
          1000;
        let config = {
          headers: {
            "0Card-Merchant-Id": vm.zc_merchant_id,
            "0Card-API-Key": vm.zc_api_key,
            "Content-Type": "application/json",
          },
        };
        let data = {
          order_id: order_no,
          product_name: order_data.product.name,
          amount: order_data.pay.total_price,
          installment: order_data.pay.staging,
          fee_type: "vendor",
          notify_url: "https://rerace.yongxin-design.com/api/ZCPay/notify.php",
          display_url:
            "https://rerace.yongxin-design.com/checkout_result/after_pay?name=" +
            order_data.name +
            "&phone=" +
            order_data.phone +
            "&email=" +
            order_data.email +
            "&order_id=" +
            order_no,
          valid_days: 7,
          customer_info: "1",
          //"top_vender_id": vm.zc_top_vender_id
        };

        this.axios
          .post(url, data, config)
          .then((response) => {
            if (response.data.result == "000") {
              //送資料去php存到sql
              this.SaveZeroCardOrderData(response.data, order_data, order_no);
              resolve(response.data);
            } else {
              //顯示錯誤
              this.$store.commit("SetLoading", false);
              alert(response.data.result_message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    },
    SaveZeroCardOrderData(zero_card_data, order_data, order_no) {
      order_data.order_no = order_no;

      this.axios
        .post(
          process.env.VUE_APP_BASE_API + "0card/SaveOrder.php",
          JSON.stringify(order_data)
        )
        .then((response) => {
          if (response.data.status == "success") {
            document.location.href =
              zero_card_data.info_reserve.payment_url_web;
          }
        });
    },
  },
};
